module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Db-Fb-Gb-Hc-Ia.1c6c0a8a.png";